import styled from 'styled-components'

import ControlSliderArrows from 'components/ControlSliderArrows'

export const ControlSliderArrowsStyled = styled(ControlSliderArrows)`
  padding: 0 ${p => p.theme.indents.baseIndentXs};
`
